import { matchQuery, MutationCache, QueryClient, Query } from "@tanstack/react-query";

export const mutationCache = new MutationCache({
  onSuccess: (_data, _variables, _context, mutation): Promise<unknown> | undefined => {
    // Remove queries that are explicitly included in the removes array
    if (mutation.meta?.removes?.length) {
      queryClient.removeQueries({
        predicate: (query: Query) => {
          return mutation.meta?.removes?.some((queryKey) => matchQuery({ queryKey }, query)) ?? false;
        },
      });
    }

    // Invalidate queries that are explicitly included in the invalidates array
    if (mutation.meta?.invalidates?.length) {
      return queryClient.invalidateQueries({
        predicate: (query: Query) => {
          return mutation.meta?.invalidates?.some((queryKey) => matchQuery({ queryKey }, query)) ?? false;
        },
      });
    }

    return undefined;
  },
});

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
  mutationCache,
});
